import Cookies from 'universal-cookie';
import {
  ACTIVE_ACCOUNT_HEADER,
  ACTIVE_SESSION_HEADER,
  activeAccountIdStore,
  activeSessionIdStore,
} from '@customerio/hydra-session-state';
import { getAppVersion } from '@/utils/version';
import { isEmptyString } from '@/utils/string';

/**
 * Shared auth/session headers for Services API requests.
 *
 * Used by the typed API clients and raw fetch callers (multipart
 * uploads) so auth header changes happen in one place.
 */
export function getAuthHeaders(): Record<string, string> {
  const cookies = new Cookies();
  const accessToken = cookies.get('_access');
  const activeAccountId = activeAccountIdStore.get();

  return {
    'x-ui-version': getAppVersion(),
    [ACTIVE_SESSION_HEADER]: activeSessionIdStore.get().toString(),
    // Only send a positive account selection. 0/absent means the login's home
    // account, so omitting the header is equivalent — and it keeps this
    // (CORS-preflighted) header off the requests of users who never switch
    // accounts. Mirrors the bootstrap fetch in hydra-authentication.
    ...(activeAccountId > 0 ? { [ACTIVE_ACCOUNT_HEADER]: activeAccountId.toString() } : {}),
    ...(isEmptyString(accessToken) ? {} : { Authorization: `Bearer ${accessToken}` }),
  };
}
